import React, {Component} from 'react';
import {connect} from 'react-redux';
import BillingActions from '../../redux/BillingRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import PageWithTable from '../../components/PageWithTable';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';
import dateFormat from 'dateformat';

const columns = t => ([
  {
    key: 'fullName',
    dataKey: 'fullName',
    title: t('Client'),
    sortable: true,
    minWidth: 320,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.vin',
    dataKey: 'car.vin',
    title: t('VIN'),
    sortable: true,
    minWidth: 160,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.system.date',
    dataKey: 'car.system.date',
    title: t('BillingDate'),
    sortable: true,
    width: 0,
    flexGrow: 1,
    cellRenderer: ({cellData}) => dateFormat(cellData, 'dd.mm.yyyy'),
  },
  {
    key: 'car.system.status',
    dataKey: 'car.system.status',
    title: t('BillingStatus'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.system.tariff',
    dataKey: 'car.system.tariff',
    title: t('BillingTariff'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.system.tariffDateStart',
    dataKey: 'car.system.tariffDateStart',
    title: t('BillingTariffDateStart'),
    sortable: true,
    width: 0,
    flexGrow: 1,
    cellRenderer: ({cellData}) => dateFormat(cellData, 'dd.mm.yyyy'),
  },
  {
    key: 'car.system.tariffDateEnd',
    dataKey: 'car.system.tariffDateEnd',
    title: t('BillingTariffDateEnd'),
    sortable: true,
    width: 0,
    flexGrow: 1,
    cellRenderer: ({cellData}) => dateFormat(cellData, 'dd.mm.yyyy'),
  },
]);

const rowRenderer = ({rowData, cells}) => {
  if (rowData.rowSpan && rowData.rowSpan > 1) {
    for (let index = 0; index < 2; index++) {
      const cell = cells[index];
      const style = {
        ...cell.props.style,
        backgroundColor: 'white',
        height: rowData.rowSpan * 50 - 1,
        alignSelf: 'flex-start',
        zIndex: 1,
      };
      cells[index] = React.cloneElement(cell, {style});
    }
  }
  return cells;
}

class BillingPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filterParams: {},
    }
  }

  getData = (params) => {
    this.setState({filterParams: params});
    this.props.getBilling(params);
  }

  downloadXls = () => {
    const {filterParams} = this.state;
    this.props.downloadBilling(filterParams);
  }

  render() {
    const {
      data,
      fetching,
      totalPages,
      dictionaries,
      getDictionaries,
      permissions,
      t,
      downloadFetching
    } = this.props;
    
    if (!permissions.billing) {
      return <Forbidden />;
    }

    return (
      <PageWithTable
        customButton={{
          title: t('Download'),
          action: this.downloadXls,
          fetching: downloadFetching,
        }}
        filters={[
          {
            keyName: 'isActive',
            placeholder: t('By status'),
            data: [{
              id: true,
              name: t('ACTIVE'),
            }, {
              id: false,
              name: t('INACTIVE'),
            }]
          },
          {
            keyName: 'tariffTypeIds',
            placeholder: t('By tariff type'),
            data: dictionaries.tariffTypes.data,
            fetching: dictionaries.tariffTypes.fetching,
            getData: getDictionaries('tariffTypes'),
          },
          {
            keyName: 'tariffDateStart',
            placeholder: t('By tariff date start'),
            type: 'date',
          },
          {
            keyName: 'tariffDateEnd',
            placeholder: t('By tariff date end'),
            type: 'date',
          },
        ]}
        dataColumns={columns(t)}
        data={data}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={this.getData}
        {...this.props}
        permissions={permissions.client}
        rowRenderer={rowRenderer}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    data: state.billing.data,
    totalPages: state.billing.totalPages,
    fetching: state.billing.fetching,
    downloadFetching: state.billing.downloadFetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBilling: params => dispatch(BillingActions.billingRequest(params)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
    downloadBilling: params => dispatch(BillingActions.billingDownloadRequest(params)),
  };
};

export default withTranslation('billing', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingPage));
